import DashboardOverview from 'components/overview/DashboardOverview';
import React from 'react';

const Home = () => {
  return <DashboardOverview />;
};

export default Home;
